import React from "react";
import { navigateTo } from "gatsby-link";

import Layout from '../containers/layout'
import Container from '../components/styled-components/Container'
import SEO from '../components/seo'

import Box from '../components/styled-system/Box'
import Hero from '../components/Hero'
import InputText from '../components/styled-components/InputText'
import TextArea from '../components/styled-components/TextArea'
import FormLabel from '../components/styled-components/FormLabel'
import Button from '../components/styled-components/Button'
import '../css/form.css'

function encode(data) {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return formData;
}

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleAttachment = e => {
    this.setState({ [e.target.name]: e.target.files[0] });
  };

  handleSubmit = e => {
    e.prarticleDefault();
    const form = e.target;
    fetch("/", {
      method: "POST",
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => navigateTo(form.getAttribute("action")))
      .catch(error => alert(error));
  };

  render() {
    return (
        <Layout>
            <SEO title='Suggest an article' />
            <Hero 
              title="Suggest an article." 
              subtitle="Do you run or know of an impactful article we should be listing?" 
            />
            <Container>
              
                <Box maxWidth="672px" my={['4', '5']} mx={['0', 'auto']}>
          
                  <form
                  name="suggest-article"
                  method="post"
                  action="/success/"
                  data-netlify="true"
                  data-netlify-honeypot="bot-field"
                  onSubmit={this.handleSubmit}
                  >
                      <p hidden>
                          <label>
                          Don’t fill this out:{" "}
                          <InputText name="bot-field" onChange={this.handleChange} />
                          </label>
                          {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
                          <InputText type="hidden" name="form-name" value="suggest-article" />
                      </p>
                      <Box mb="3">
                          <FormLabel htmlFor="contact-name">What is your full name?*</FormLabel>
                          <InputText id="contact-name" name="contact-name" placeholder="e.g. John Doe" type="text" onChange={this.handleChange}/>
                      </Box>
                      <Box mb="3">
                          <FormLabel htmlFor="contact-email">What is your email address?*</FormLabel>
                          <InputText id="contact-email" name="email" placeholder="e.g. john@apple.com" type="email" onChange={this.handleChange}/>
                      </Box>
                      <Box mb="3">
                          <FormLabel htmlFor="article-url">Please provide an article URL*</FormLabel>
                          <InputText id="article-url" name="article-url" placeholder="e.g. https://startupmicrodose.com/" type="text" onChange={this.handleChange}/>
                      </Box>
    
                      <Box mb="3">
                          <FormLabel htmlFor="article-description">Please provide a short description of the article*</FormLabel>
                          <TextArea id="article-description" name="description" placeholder="article description..." type="text" onChange={this.handleChange}/>
                      </Box>
                      <Box mb="3">
                          <FormLabel htmlFor="article-takeaways">What are the top 3 takeaways for readers?*</FormLabel>
                          <TextArea id="article-takeaways" name="takeaways" placeholder="article takeaways..." type="text" onChange={this.handleChange}/>
                      </Box>
                      <Box>
                          <Button id="submit-button" type="submit">Submit article for appoval</Button>
                      </Box>
                  </form>
                </Box>
            </Container>
        </Layout>
    );
  }
}